import { Routes, Route, Navigate, useLocation } from 'react-router';
import type { ReactNode } from 'react';
import { useAppStore } from './store/useAppStore';
import { KeyRoute } from './routes/KeyRoute';
import { ChordsRoute } from './routes/ChordsRoute';
import { ScalesRoute } from './routes/ScalesRoute';
import { ProgressionsRoute } from './routes/ProgressionsRoute';
import { SettingsRoute } from './routes/SettingsRoute';
import { AboutRoute } from './routes/AboutRoute';
import { LicensesRoute } from './routes/LicensesRoute';
import { NotFoundRoute } from './routes/NotFoundRoute';

function RequireKey({ children }: { children: ReactNode }) {
  const hasKey = Boolean(useAppStore((s) => s.selectedKeyId));
  const location = useLocation();
  if (!hasKey) return <Navigate to="/" replace state={{ from: location.pathname }} />;
  return <>{children}</>;
}

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<KeyRoute />} />
      <Route
        path="/chords"
        element={
          <RequireKey>
            <ChordsRoute />
          </RequireKey>
        }
      />
      <Route
        path="/scales"
        element={
          <RequireKey>
            <ScalesRoute />
          </RequireKey>
        }
      />
      <Route
        path="/progressions"
        element={
          <RequireKey>
            <ProgressionsRoute />
          </RequireKey>
        }
      />
      <Route path="/settings" element={<SettingsRoute />} />
      <Route path="/about" element={<AboutRoute />} />
      <Route path="/licenses" element={<LicensesRoute />} />
      <Route path="*" element={<NotFoundRoute />} />
    </Routes>
  );
}
